export default __webpack_public_path__ + "static/media/event-prop-3.8131ace9.png";